// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"20afc832","251":"6b1b2f82"}[chunkId] + ".chunk.js";
};